export default __webpack_public_path__ + "static/media/arrow.ed53b720.svg";